import { useEffect, useState } from "react";

/** Splits a millisecond duration into whole hours/minutes/seconds (clamped at 0). */
export function getCountdownParts(remainingMs) {
  const totalSeconds = Math.max(0, Math.floor((Number(remainingMs) || 0) / 1000));
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    isComplete: totalSeconds === 0,
  };
}

/**
 * Ticks once a second towards `targetIso`. `serverNowIso` corrects for a wrong
 * clock on the customer's phone: the offset between server and device time is
 * captured once and applied to every tick.
 */
export default function useCountdown(targetIso, serverNowIso) {
  const targetMs = Date.parse(targetIso);
  const [offsetMs] = useState(() => {
    const serverMs = Date.parse(serverNowIso);
    return Number.isFinite(serverMs) ? serverMs - Date.now() : 0;
  });
  const remaining = () => (Number.isFinite(targetMs) ? targetMs - (Date.now() + offsetMs) : 0);
  const [parts, setParts] = useState(() => getCountdownParts(remaining()));

  useEffect(() => {
    if (!Number.isFinite(targetMs)) return undefined;
    const tick = () => setParts(getCountdownParts(targetMs - (Date.now() + offsetMs)));
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [targetMs, offsetMs]);

  return parts;
}
